import { FULL_PAGE_NOTIFICATIONS_PAGE, FULL_PAGE_NOTIFICATIONS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const notificationsRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	layout: 'expanded',
	name: FULL_PAGE_NOTIFICATIONS_PAGE,
	path: FULL_PAGE_NOTIFICATIONS_PATH,
});
